// extracted by mini-css-extract-plugin
export default {"description":"description-module___description___b21a75da"};